import { useQuery } from '@apollo/client';
import { shapeOrders } from './shapeOrders';
import type { IUseOrders } from './orderHistory.interface';
export type { IUseOrders, IOrder, IOrderFilters } from './orderHistory.interface';
import { ordersGql } from './gql';

export const useOrders = ({ filters }: IUseOrders) => {
  const { loading, data, error } = useQuery(ordersGql, {
    context: {
      headers: {
        userFunctionKey: '9a1158154dfa42caddbd0694a4e9bdc8'
      }
    },
    variables: filters,
    skip: filters?.personId === 0
  });

  let orders;
  if (!loading) {
    orders = shapeOrders(data?.Orders);
  }

  return { loading, orders, error };
};
